// export const generatePrintTemplate = (qrUrl: string) => {
//   return `
// <!DOCTYPE html>
// <html lang="en">
// <head>
//     <meta charset="UTF-8">
//     <meta name="viewport" content="width=device-width, initial-scale=1.0">
//     <title>SDS Information QR Code</title>
//     <style>
//         @page {
//             size: A4;
//             margin: 20mm;
//         }

//         * {
//             margin: 0;
//             padding: 0;
//             box-sizing: border-box;
//         }

//         body {
//             font-family: Arial, sans-serif;
//             background: white;
//             display: flex;
//             justify-content: center;
//             align-items: center;
//             min-height: 100vh;
//             padding: 20px;
//         }

//         .qr-container {
//             width: 400px;
//             height: 550px;
//             background: white;
//             border: 3px solid #000;
//             display: flex;
//             flex-direction: column;
//             align-items: center;
//             justify-content: space-between;
//             padding: 30px;
//             box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
//         }

//         .header {
//             text-align: center;
//             margin-bottom: 20px;
//         }

//         .title {
//             font-size: 36px;
//             font-weight: bold;
//             color: #000;
//             margin-bottom: 10px;
//             letter-spacing: 2px;
//         }

//         .subtitle {
//             font-size: 28px;
//             font-weight: bold;
//             color: #000;
//             letter-spacing: 1px;
//         }

//         .qr-frame {
//             width: 280px;
//             height: 280px;
//             background: #8FBC8F;
//             border: 3px solid #000;
//             position: relative;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//         }

//         .qr-frame::before,
//         .qr-frame::after {
//             content: '';
//             position: absolute;
//             width: 20px;
//             height: 20px;
//             border: 3px solid #000;
//         }

//         .qr-frame::before {
//             top: 10px;
//             left: 10px;
//             border-right: none;
//             border-bottom: none;
//         }

//         .qr-frame::after {
//             top: 10px;
//             right: 10px;
//             border-left: none;
//             border-bottom: none;
//         }

//         .qr-frame .corner-bottom-left {
//             position: absolute;
//             bottom: 10px;
//             left: 10px;
//             width: 20px;
//             height: 20px;
//             border: 3px solid #000;
//             border-right: none;
//             border-top: none;
//         }

//         .qr-frame .corner-bottom-right {
//             position: absolute;
//             bottom: 10px;
//             right: 10px;
//             width: 20px;
//             height: 20px;
//             border: 3px solid #000;
//             border-left: none;
//             border-top: none;
//         }

//         .qr-code {
//             width: 220px;
//             height: 220px;
//             background: white;
//             border: 2px solid #fff;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//         }

//         .footer {
//             display: flex;
//             align-items: center;
//             gap: 10px;
//             margin-top: 20px;
//         }

//         .logo {
//             display: flex;
//             align-items: center;
//             gap: 10px;
//         }

//         .logo-text {
//             font-size: 36px;
//             font-weight: bold;
//             color: #8FBC8F;
//             letter-spacing: 1px;
//         }

//         .company-info {
//             font-size: 12px;
//             color: #666;
//             text-transform: uppercase;
//             line-height: 1.3;
//             letter-spacing: 0.5px;
//         }

//         @media print {
//             body {
//                 background: white;
//                 padding: 0;
//                 margin: 0;
//             }

//             .qr-container {
//                 box-shadow: none;
//                 page-break-inside: avoid;
//             }

//             @page {
//                 margin: 0.5in;
//             }
//         }
//     </style>
// </head>
// <body>
//     <div class="qr-container">
//         <div class="header">
//             <div class="title">SDS</div>
//             <div class="subtitle">INFORMATION</div>
//         </div>

//         <div class="qr-frame">
//             <div class="corner-bottom-left"></div>
//             <div class="corner-bottom-right"></div>
//             <div class="qr-code" id="qrcode">
//                 <!-- QR Code will be generated here -->
//             </div>
//         </div>

//         <div class="footer">
//             <div class="logo">
//                 <span class="logo-text">KSI</span>
//                 <div class="company-info">
//                     INTEGRATED<br>
//                     FACILITY<br>
//                     SERVICES
//                 </div>
//             </div>
//         </div>
//     </div>

//     <script src="https://cdnjs.cloudflare.com/ajax/libs/qrious/4.0.2/qrious.min.js"></script>
//     <script>
//         window.onload = function() {
//             const canvas = document.createElement('canvas');
//             const qr = new QRious({
//                 element: canvas,
//                 value: '${qrUrl}',
//                 size: 220,
//                 background: 'white',
//                 foreground: 'black',
//                 level: 'M'
//             });

//             document.getElementById('qrcode').appendChild(canvas);

//             // Auto print after loading
//             setTimeout(() => {
//                 window.print();
//                 window.close();
//             }, 500);
//         };
//     </script>
// </body>
// </html>`;
// };

// import { DBLocation } from "src/types";

// export const generatePrintTemplate = (
//   qrUrl: string,
//   collapsedLogoSrc: string = "",
//   appLogoSrc: string = "",
//   primaryColor: string = "#000",
//   location: DBLocation,
//   washroomLabel: string,
// ) => {
//   return `
// <!DOCTYPE html>
// <html lang="en">
// <head>
//     <meta charset="UTF-8">
//     <meta name="viewport" content="width=device-width, initial-scale=1.0">
//     <title>${location.label} - Washroom Logs QR code</title>
//     <style>
//         @page {
//             size: A4;
//             margin: 0;
//         }

//         * {
//             margin: 0;
//             padding: 0;
//             box-sizing: border-box;
//         }

//         body {
//             font-family: Arial, sans-serif;
//             background: white;
//             display: flex;
//             justify-content: center;
//             align-items: center;
//             min-height: 100vh;
//             padding: 0;
//         }

//         .page-container {
//             width: 216mm;
//             min-height: 279mm;
//             background: white;
//             display: flex;
//             flex-direction: column;
//             padding: 40px 50px 20px 50px;
//             position: relative;
//         }

//         .header {
//             margin-bottom: 20px;
//         }

//         .logo-container {
//             margin-bottom: 15px;
//             display: flex;
//             align-items: center;
//             gap: 2px;
//         }

//         .collapsed-logo {
//             width: 40px;
//             height: 40px;
//             object-fit: contain;
//         }

//         .app-logo {
//             height: 50px;
//             object-fit: contain;
//         }

//         .divider {
//             width: 100%;
//             height: 2px;
//             background: #000;
//             margin: 20px 0;
//         }

//         .title {
//             font-size: 48px;
//             font-weight: 700;
//             text-align: center;
//             margin-top: 150px;
//             margin-bottom: 40px;
//             color: ${primaryColor};
//             font-family: 'Avenir Next LT Pro', 'Avenir Next', 'Avenir', sans-serif;
//             text-transform: uppercase;
//             text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.15);
//             background-color: #fff;
//         }

//         .content {
//             flex: 1;
//             display: flex;
//             flex-direction: column;
//             align-items: center;
//             justify-content: center;
//         }

//         .qr-wrapper {
//             display: flex;
//             justify-content: center;
//             align-items: center;
//             margin: 40px 0;
//         }

//         .qr-code {
//             width: 300px;
//             height: 300px;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//         }

//         .qr-code canvas {
//             max-width: 100%;
//             max-height: 100%;
//         }

//         .footer {
//             text-align: center;
//             margin-top: auto;
//             padding-top: 40px;
//         }

//         .footer-text {
//             font-size: 13px;
//             color: #000;
//             line-height: 1.8;
//         }

//         .footer-text a {
//             color: #000;
//             text-decoration: none;
//         }

//         .footer-text a:hover {
//             text-decoration: underline;
//         }

//         /* Always render washroom label at bottom-right for print */
//         .washroom-label {
//             position: absolute;
//             right: 50px;
//             bottom: -50px;
//             font-size: 12px;
//             color: #000;
//             text-align: right;
//         }

//         @media print {
//             body {
//                 background: white;
//                 padding: 0;
//                 margin: 0;
//             }

//             .page-container {
//                 box-shadow: none;
//                 page-break-inside: avoid;
//             }

//             .title {
//                 color: ${primaryColor} !important;
//                 -webkit-print-color-adjust: exact;
//                 print-color-adjust: exact;
//                 color-adjust: exact;
//             }

//             @page {
//                 margin: 0;
//             }
//         }
//     </style>
// </head>
// <body>
//     <div class="page-container">
//         <div class="header">
//             <div class="logo-container">
//                 <!-- Collapsed Logo -->
//                 <!-- <img src="${collapsedLogoSrc}" alt="KSI Logo" class="collapsed-logo" /> -->

//                 <!-- App Logo -->
//                 <img src="${appLogoSrc}" alt="KSI Integrated Facility Services" class="app-logo" />
//             </div>

//             <!-- <div class="divider"></div> -->

//             <div class="title">WASHROOM CLEANING LOG</div>
//         </div>

//         <div class="content">
//             <div class="qr-wrapper">
//                 <div class="qr-code" id="qrcode">
//                     <!-- QR Code will be generated here -->
//                 </div>
//             </div>
//         </div>

//         <div class="footer">
//             <div class="footer-text">
//                 For any questions, concerns, or feedback,
//                 please contact <a href="mailto:info@ksiintegrated.com">info@ksiintegrated.com</a>
//             </div>
//         </div>

//         <div class="washroom-label">${washroomLabel}</div>
//     </div>

//     <script src="https://cdnjs.cloudflare.com/ajax/libs/qrious/4.0.2/qrious.min.js"></script>
//     <script>
//         window.onload = function() {
//             const canvas = document.createElement('canvas');
//             const qr = new QRious({
//                 element: canvas,
//                 value: '${qrUrl}',
//                 size: 700,
//                 background: 'white',
//                 foreground: 'black',
//                 level: 'M'
//             });

//             document.getElementById('qrcode').appendChild(canvas);

//             // Auto print after loading (optional - remove if not needed)
//             setTimeout(() => {
//                 window.print();
//                 // window.close(); // Uncomment if you want to auto-close
//             }, 500);
//         };
//     </script>
// </body>
// </html>`;
// };

import { DBLocation } from "src/types";

export const generatePrintTemplate = (
  qrUrl: string,
  appLogoSrc: string = "",
  primaryColor: string = "#000",
  location: DBLocation,
  washroomLabel: string,
  clientName: string,
) => {
  return `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>${location.label} - Washroom Logs QR code</title>
    <style>
        @page {
            size: A4;
            margin: 0;
        }

        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }

        body {
            font-family: Arial, sans-serif;
            background: white;
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 100vh;
            padding: 0;
        }

        .page-container {
            width: 210mm;
            height: 297mm;
            background: white;
            display: flex;
            flex-direction: column;
            position: relative;
        }

        .half-section {
            width: 210mm;
            height: 148.5mm;
            display: flex;
            flex-direction: column;
            padding: 20px 20px;
            position: relative;
            border-bottom: 1px dashed #ccc;
        }

        .half-section:last-child {
            border-bottom: none;
        }

        .header {
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
        }

        .logo-container {
            display: flex;
            align-items: center;
            gap: 8px;
            background-color: #fff;
        }

        .collapsed-logo {
            width: 32px;
            height: 32px;
            object-fit: contain;
        }

        .app-logo {
            height: 42px;
            object-fit: contain;
        }

        .washroom-label {
            position: absolute;
            right: 30px;
            bottom: 20px;
            font-size: 9px;
            color: #000;
            text-align: right;
        }

        .customer-details-label {
            position: absolute;
            right: 30px;
            bottom: 8px;
            font-size: 9px;
            color: #000;
            text-align: right;
        }

        .content {
            flex: 1;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            gap: 20px;
            padding: 0 20px;
        }

        .title {
            font-size: 38px;
            font-weight: 700;
            text-align: left;
            color: ${primaryColor};
            font-family: 'Avenir Next LT Pro', 'Avenir Next', 'Avenir', sans-serif;
            text-transform: uppercase;
            letter-spacing: 2px;
            line-height: 1.2;
            flex: 1;
        }

        // .qr-wrapper {
        //     display: flex;
        //     flex-direction: column;
        //     align-items: center;
        //     justify-content: center;
        //     gap: 10px;
        // }

        .scan-label {
            background-color: #3d2517;
            color: white;
            padding: 6px 20px;
            font-size: 11px;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 1px;
        }

        // .qr-frame {
        //     width: 180px;
        //     height: 180px;
        //     border: 3px solid #3d2517;
        //     border-radius: 8px;
        //     padding: 10px;
        //     display: flex;
        //     align-items: center;
        //     justify-content: center;
        // }

        .qr-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    position: relative;
}

.qr-frame {
    width: 180px;
    height: 180px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    margin-bottom: 30px;
}

/* Top-left corner */
.qr-frame::before {
    content: '';
    position: absolute;
    top: -12px;
    left: -12px;
    width: 35px;
    height: 35px;
    border-top: 8px solid #3d2517;
    border-left: 8px solid #3d2517;
    z-index: 3;
}

/* Top-right corner */
.qr-frame::after {
    content: '';
    position: absolute;
    top: -12px;
    right: -12px;
    width: 35px;
    height: 35px;
    border-top: 8px solid #3d2517;
    border-right: 8px solid #3d2517;
    z-index: 3;
}

/* Bottom-left corner */
.qr-wrapper::before {
    content: '';
    position: absolute;
    bottom: 18px;
    left: 42%;
    transform: translateX(-90px);
    width: 35px;
    height: 35px;
    border-bottom: 8px solid #3d2517;
    border-left: 8px solid #3d2517;
    z-index: 3;
}

/* Bottom-right corner */
.qr-wrapper::after {
    content: '';
    position: absolute;
    bottom: 18px;
    right: 42%;
    transform: translateX(90px);
    width: 35px;
    height: 35px;
    border-bottom: 8px solid #3d2517;
    border-right: 8px solid #3d2517;
    z-index: 3;
}

.qr-code {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 1;
}

        .qr-code {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .qr-code canvas {
            max-width: 100%;
            max-height: 100%;
        }

        .footer {
            text-align: center;
            padding-bottom: 10px;
        }

        .footer-text {
            font-size: 9px;
            color: #000;
            line-height: 1.5;
        }

        .footer-text a {
            color: #000;
            text-decoration: none;
        }

        .footer-text a:hover {
            text-decoration: underline;
        }

        @media print {
            body {
                background: white;
                padding: 0;
                margin: 0;
            }

            .page-container {
                box-shadow: none;
                page-break-inside: avoid;
            }

            .half-section {
                page-break-inside: avoid;
            }

            .title-container {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                gap: 30px;
                align-items: flex-end;
            }

            .title {
                color: ${primaryColor} !important;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
                color-adjust: exact;
                text-align: right !important;
            }

            .scan-label {
            background-color: #3d2517 !important;
            color: white !important;
            padding: 6px 20px;
            font-size: 11px;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 1px;
        }

            .footer-text {
                text-align: right !important;
            }

            @page {
                margin: 0;
            }
        }
    </style>
</head>
<body>
    <div class="page-container">
        <!-- First Half -->
        <div class="half-section">
            <div class="header">
                <div class="logo-container">
                    <img src="${appLogoSrc}" alt="Company Logo" class="app-logo" />
                </div>
            </div>

            <div class="content">
                <div class="title-container">
                    <div class="title">WASHROOM CLEANING<br>LOG</div>
                    <div class="footer">
                    <div class="footer-text">
                        For any questions, concerns, or feedback, please contact<br>
                        <a href="mailto:info@ksintegrated.com">info@ksintegrated.com</a>
                    </div>
                </div>
                </div>
                
                <div class="qr-wrapper">
                    <div class="scan-label">SCAN HERE</div>
                    <div class="qr-frame">
                        <div class="qr-code" id="qrcode1">
                            <!-- QR Code will be generated here -->
                        </div>
                    </div>
                </div>
            </div>

            <div class="washroom-label">${washroomLabel}</div>
            <div class="customer-details-label">
                ${clientName} - ${location.label}
            </div>
        </div>

        <!-- Second Half -->
        <div class="half-section">
            <div class="header">
                <div class="logo-container">
                    <img src="${appLogoSrc}" alt="Company Logo" class="app-logo" />
                </div>
            </div>

            <div class="content">
                <div class="title-container">
                    <div class="title">WASHROOM CLEANING<br>LOG</div>
                    <div class="footer">
                    <div class="footer-text">
                        For any questions, concerns, or feedback, please contact<br>
                        <a href="mailto:info@ksintegrated.com">info@ksintegrated.com</a>
                    </div>
                </div>
                </div>
                
                <div class="qr-wrapper">
                    <div class="scan-label">SCAN HERE</div>
                    <div class="qr-frame">
                        <div class="qr-code" id="qrcode2">
                            <!-- QR Code will be generated here -->
                        </div>
                    </div>
                </div>
            </div>

            <div class="washroom-label">${washroomLabel}</div>
            <div class="customer-details-label">
                ${clientName} - ${location.label}
            </div>
        </div>
    </div>

    <script src="https://cdnjs.cloudflare.com/ajax/libs/qrious/4.0.2/qrious.min.js"></script>
    <script>
        window.onload = function() {
            // Generate first QR code
            const canvas1 = document.createElement('canvas');
            const qr1 = new QRious({
                element: canvas1,
                value: '${qrUrl}',
                size: 500,
                background: 'white',
                foreground: 'black',
                level: 'M'
            });
            document.getElementById('qrcode1').appendChild(canvas1);

            // Generate second QR code
            const canvas2 = document.createElement('canvas');
            const qr2 = new QRious({
                element: canvas2,
                value: '${qrUrl}',
                size: 500,
                background: 'white',
                foreground: 'black',
                level: 'M'
            });
            document.getElementById('qrcode2').appendChild(canvas2);
            
            // Auto print after loading
            setTimeout(() => {
                window.print();
                // window.close(); // Uncomment if you want to auto-close
            }, 500);
        };
    </script>
</body>
</html>`;
};
